import React from "react"

const DescriptionWrapper = ({children}) => {
  return (
    <div
      className="description--wrapper"
   
    >
      {children}
    </div>
  )
}
export default DescriptionWrapper
